<template>
  <v-card>
    <v-card-title> Resource Images </v-card-title>
    <v-divider />
    <ImageUpload
      height="120"
      class="ma-4"
      :saving="saving"
      @save="add($event)"
    />
    <v-card-text>
      <v-data-table
        disable-pagination
        hide-default-footer
        :headers="[
          { text: '', value: 'imageUrl' },
          { text: 'Name', value: 'fileName' },
          { text: '', value: 'actions' }
        ]"
        :items="resource_images"
      >
        <template #[`item.imageUrl`]="{ item }">
          <v-img
            class="my-1"
            :src="item.imageUrl"
            height="100"
            contain
            max-width="100"
          />
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            icon
            :loading="deleting"
            @click="deleteImage(item)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ImageUpload from '@/components/common/ImageUpload';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductResourceImages',
  components: { ImageUpload },
  data() {
    return { deleting: false, saving: false };
  },
  computed: {
    ...mapGetters({
      product: 'products/product',
      resource_images: 'products/resource_images'
    })
  },
  methods: {
    add(e) {
      this.saving = true;
      this.$store
        .dispatch('products/addResourceImage', {
          coreProductId: this.product.id,
          file: e.target.files[0]
        })
        .then(() => {
          this.$root.$snackbarSuccess('Image added');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    async deleteImage(item) {
      if (
        await this.$root.$confirm('Delete Image', 'Are you sure you want to delete this image?', {
          color: 'error'
        })
      ) {
        this.deleting = true;
        this.$store
          .dispatch('products/deleteResourceImage', { id: item.id, coreProductId: this.product.id })
          .then(() => {
            this.$root.$snackbarSuccess('Image deleted');
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.deleting = false;
          });
      }
    }
  }
};
</script>
